import AxiosClient from "@/helpers/AxiosClient";

// Tenant home sayfa ömrü boyunca değişmez (slug host'tan gelir) — tek slotluk
// promise cache, picker -> menü geçişindeki mükerrer isteği keser. Hata alan
// promise cache'te bırakılmaz ki sonraki deneme yeniden istesin.
let homeCache = null;

export const getTenantHome = (tenantSlug) => {
  if (!homeCache) {
    homeCache = AxiosClient.get(
      `/tenants/${encodeURIComponent(tenantSlug)}`,
    ).catch((err) => {
      homeCache = null;
      throw err;
    });
  }
  return homeCache;
};

export const getBranchMenu = (tenantSlug, branchSlug) => {
  return AxiosClient.get(
    `/tenants/${encodeURIComponent(tenantSlug)}/branches/${encodeURIComponent(branchSlug)}/menu`,
  );
};
